import { LocaleType } from './Locale';

const theLocale: LocaleType = {
    locale: 'jp',
    conver: 'ja-JP',
    alia: 'ja',
    region: 'Japan',
    regionText: '日本',
    language: 'Japanese',
    languageText: '日本語',
    appId: 5,
    acceptLanguage: 'ja-JP,ja;q=0.9',
};
export default theLocale;
